<template>
	<div id="legal">
		<div class="inner" v-html="ppDetail[localeCode]"></div>
	</div>
</template>

<script>
export default {
	name: 'PrivacyPolicy',
	data() {
		return {
			ppDetail: [],
		};
	},
	created() {
		this.$http.get(`${this.cdnHost}/frontend/v2/${environment.region}/pp/detail.json`).then((response) => {
			this.ppDetail = response.data;
		});
	},
};
</script>
